import React from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import { Form, Modal, Grid, Row, Col } from 'react-bootstrap';
import RecoveryEmail from './RecoveryEmail';
import ChangePassword from './ChangePassword';

const PasswordReset = props => (
  <Modal show={props.show} className="fullwidth-modal">
    <Grid fluid>
      <Modal.Header>
        <Row>
          <Col xs={4} md={1}>
            <Link to="/" className="meet-litpog" />
          </Col>
          <Col xs={6} md={10} />
          <Col xs={2} md={1}>
            <span className="litpog-remove" onClick={props.handleModalClose} />
          </Col>
        </Row>
      </Modal.Header>
    </Grid>
    <Modal.Body>
      <Form>
        {!props.reset_password_token ? (
          <RecoveryEmail handleModalClose={props.handleModalClose} setMessage={props.setMessage} />
        ) : (
          <ChangePassword
            reset_password_token={props.reset_password_token}
            clearPasswordToken={props.clearPasswordToken}
            handleModalClose={props.handleModalClose}
            setMessage={props.setMessage}
            clearRouterHistorySearch={props.clearRouterHistorySearch}
          />
        )}
      </Form>
    </Modal.Body>
  </Modal>
);

export default withRouter(PasswordReset);



// WEBPACK FOOTER //
// ./src/components/Login/PasswordReset.js